import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reingestorCreateVideoPromise, CreateVideoSchema } from 'src/utils/api/reingestor';
import { QUERY_KEY_MAP } from 'src/constants/query-key';
import { useNotification } from 'src/hooks';
import { useGetUserDetails } from '../use-get-user-details';

export const useReingestorCreateVideo = () => {
  const { userDetails } = useGetUserDetails();

  const { enqueueErrorNotification, enqueueSuccessNotification } = useNotification();

  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: reingestorCreateVideoPromise,
  });

  const createVideoAsync = async (param: Omit<CreateVideoSchema, 'email_address'>) => {
    try {
      const result = await mutateAsync({
        ...(param || {}),
        email_address: userDetails?.email || '',
      });

      if (!result) {
        enqueueErrorNotification('video.create.failed');
        return result;
      }

      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_MAP.useListTasks],
      });

      enqueueSuccessNotification('video.create.success');
      return result;
    } catch (e) {
      enqueueErrorNotification('video.create.failed');

      console.error('~ file: useReingestorCreateVideo.ts:16 ~ createVideoAsync ~ e:', e);
      return false;
    }
  };

  return {
    createVideoAsync,
    isLoading: isPending,
  };
};
